module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-14-04.386Z.8f086fd1.png";